import { Button } from "@legal-500/legal500-design-system";
import type { TaxonomyMode } from "@/api/submissions.service";
import styles from "./TaxonomyToggle.module.css";

const OPTIONS: { mode: TaxonomyMode; label: string }[] = [
  { mode: "legacy", label: "Old taxonomy" },
  { mode: "new", label: "New taxonomy" },
];

type TaxonomyToggleProps = {
  mode: TaxonomyMode;
  onChange: (mode: TaxonomyMode) => void;
  disabled?: boolean;
};

export function TaxonomyToggle({ mode, onChange, disabled = false }: TaxonomyToggleProps) {
  return (
    <div className={styles.toggle} role="group" aria-label="Taxonomy">
      {OPTIONS.map(option => (
        <Button
          key={option.mode}
          size="small"
          variant={mode === option.mode ? "contained" : "outlined"}
          color={mode === option.mode ? "primary" : "default"}
          aria-pressed={mode === option.mode}
          disabled={disabled}
          onClick={() => {
            if (option.mode !== mode) onChange(option.mode);
          }}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
}
